import { formatDate } from 'utils/formatDate';

export const getUnifiedTimeFormat = time =>
  (time && time >= 600000 && formatDate(time, 'mm') + ' min') ||
  (time >= 60000 && time < 600000 && formatDate(time, 'm') + ' min') ||
  (time < 60000 && time >= 10000 && formatDate(time, 'ss') + ' sec') ||
  (time < 10000 && formatDate(time, 's') + ' sec');
